export default __webpack_public_path__ + "static/media/Blog1_3.b65ee667.jpg";